import { defineFcm } from '../shared/factory';

export const FCM_COPY_LINK_ON_UNSIGNED = defineFcm('copy_link_on_unsigned').asBoolean().withDefault(false).toConfig();
